<template>
	<div class="header">
		<div class="container">
			<div class="logo">
				<img src="../../assets/img/logo.png" alt="">
				<div class="text">
					<p>大救星救援平台</p>
					<p>DaJiuXing Rescue Platform</p>
				</div>
			</div>
			<div class="nav">
				<router-link to='/stores' v-if='virtualAccount == 1'>门店</router-link>
				<router-link to='/shop'>店铺</router-link>
				<router-link v-if="category != 1" to='/commodity'>商品</router-link>
				<router-link v-if="cwshow" to='/financial'>财务</router-link>
        <router-link to='/learning'>学习中心</router-link>
				<router-link v-if="szshow" to='/setting'>设置</router-link>
			</div>
			<div class="login" @mouseover="msgBoxShow=true" @mouseleave="msgBoxShow=false">
				<a>HI,{{this.name}}</a>
				<ul class="msgBox" v-show="msgBoxShow">
					<p>机构信息：<span>{{introduce}}</span></p>
					<router-link tag='li' class="set el-icon-setting" to='/setting'> 机构设置</router-link>
					<li class="exit" @click='logOut'>退出</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import { listByState,getInfo } from '@/axios/api.js'
	export default{
		data(){
			return {
        category:0,
        szshow:false,
        cwshow:false,
        studyshow:false,
				msgBoxShow:false,
				name:JSON.parse(window.localStorage.getItem("token")).data.obj2.name,
				introduce:JSON.parse(window.localStorage.getItem("token")).data.obj.name,
				virtualAccount:JSON.parse(window.localStorage.getItem("token")).data.obj.virtualAccount,
			}
		},
		methods:{
			logOut(){
				this.msgBoxShow=false
				this.$router.push({
					path:'/'
				})
				window.localStorage.removeItem('token') 
				this.name=''
			}
		},
    mounted() {
      var data = {
        state:'',
        start: 0,
        count: 10
      }
      listByState(data).then(res => {
        // console.log(res.data.code)
        
        if(res.data.code != 102001) {
          this.cwshow = true
        }else {
          this.cwshow = false
        }
        localStorage.setItem("cwshow", this.cwshow);
      }).catch(err => {
        console.log(err)
      })
      getInfo().then(res => {
        // console.log(res.data.obj.category)
        if(res.data.code != 102001) {
          this.szshow = true
          this.category = res.data.obj.category
        }else {
          this.category = 2
          this.szshow = false
        }
        localStorage.setItem("category", this.category);
      }).catch(err => {
        console.log(err)
      })
      console.log(this.category,this.cwshow)
    }
	}
</script>

<style scoped="scoped">
.container{height: 69px;}
.header{background: #333;height: 70px;}
.logo{overflow: hidden;padding: 14px 0;float: left;}
.logo img{float: left;height: 40px;}
.logo .text{float: left;color: white;margin-left: 10px;}
.logo .text p:last-child{font-size: 14px;}
.login{float: right;line-height: 69px;max-width: 180px;position: relative;}
.login a{color: white;font-size: 14px;display: block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;}
.nav{height: 69px;float: left;margin-left: 100px;}
.nav a{color: white;line-height: 69px;display: inline-block;padding: 0 30px;font-size: 16px;}
.nav a.router-link-active{background-color: #212123;color: #00abfa;}
.nav a.router-link-exact-active{background-color: #212123;color: #00abfa;}
.nav a:hover{background-color: #212123;color: #00abfa;}
.msgBox{width: 250px;background: #333;position: absolute;top: 68px;right: 0;padding: 0 20px;z-index: 10;}
.msgBox *{color: #fff;}
.msgBox p{line-height: 60px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;border-bottom: 1px solid #666;}
.set{border-bottom: 1px solid #666;line-height: 60px;width: 100%;cursor: pointer;}
.exit{text-align: center;line-height: 50px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/components/header/inheader.vue